module.exports = "/assets/a40ffaa7bc690c89ee908f2b06a13bdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/LR.png
// module id = 1589
// module chunks = 0